import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Ne pas intercepter les requêtes vers les assets
        if (request.url.includes('assets/')) {
            return next.handle(request);
        }

        const token = this.authService.getToken();
        
        console.log('JWT Interceptor - Token:', token);
        console.log('JWT Interceptor - Original Request:', request.url);

        if (token && this.isApiRequest(request)) {
          const authReq = request.clone({
              setHeaders: {
                  'Authorization': `Bearer ${token}`,  // Ajout du préfixe Bearer
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              }
          });
          console.log('JWT Interceptor - Headers:', authReq.headers);
          return next.handle(authReq);
      }

        return next.handle(request);
    }

    private isApiRequest(request: HttpRequest<unknown>): boolean {
        return request.url.startsWith(environment.apiUrl) || 
               request.url.startsWith('/api/') ||
               !request.url.startsWith('http');
    }
}